import { memo } from 'react';
import { images } from '../../../../constants/images';
import styles from '../../publicationDetailMobile.module.scss';
import { PublicationStatusBadgeProps } from '../../../PublicationDetail/interfaces';



const PublicationStatusBadge = ({
  publication,
  type
}: PublicationStatusBadgeProps) => {
  // No mostrar badge para "myPublication"
  if (type === "myPublication" || !publication?.status_brief?.code) {
    return null;
  }

  const getStatusConfig = () => {
    const { code } = publication.status_brief;
    const { opportunity } = publication;

    if (code === "sold_out") {
      return {
        className: styles.soldBadge,
        text: "Vendido"
      };
    }

    if (code === "reserved") {
      return {
        className: styles.reservedBadge,
        text: "Reservado"
      };
    }

    return null;
  };

  const statusConfig = getStatusConfig();
  if (!statusConfig) return null;

  return (
    <div className={styles.statusBadge}>
      <span className={statusConfig.className}>
        {statusConfig.text}
      </span>
    </div>
  );
};

export default memo(PublicationStatusBadge);
